import { Button, Form, Modal } from "react-bootstrap"
import i18next from "i18next"
import _ from 'lodash';
import { useState } from "react";
import RequiredFormLabel from "../../RequiredFormLabel/RequiredFormLabel";
import { OpportunityChecklistItemDTO } from "src/api/models/Opportunities/OpportunityChecklistItemDTO";

type Props = {
  isOpen?: boolean;
  closeModal?: (reload?: boolean) => void;
  doDeleteDocument: (reason: string) => void;
  checklistItem?: OpportunityChecklistItemDTO
}

export function DeleteOpportunityDocumentModal({ isOpen, doDeleteDocument, checklistItem, closeModal = _.noop }: Props) {
  const [reason, setReason] = useState('');

  const onClose = () => {
    setReason('');
    closeModal();
  }

  if (!checklistItem) return null;

  return (
    <Modal show={isOpen}>
      <Modal.Header>
        <Modal.Title>{i18next.t('confirm')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{i18next.t('delete_checklist_item')}</p>
        <Form>
          <Form.Group className="mb-3 mt-3">
            <RequiredFormLabel label={i18next.t('motivation')} />
            <Form.Control required as="textarea" rows={3} onChange={(e) => setReason(e?.target?.value)} />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant='link' onClick={onClose}>
          {i18next.t('cancel')}
        </Button>
        <Button disabled={!reason?.trim()} onClick={() => doDeleteDocument(reason)}>
          {i18next.t('proceed')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
